import { UseCasePage } from '@/components/marketing/use-case-page'

export function UseCasesKnowledgeWorkersPage() {
  return (
    <UseCasePage
      contentKey="useCasesKnowledgeWorkers"
      path="/use-cases/knowledge-workers"
      relatedKeys={['useCasesFounders', 'whatIsKnowledgeGraph', 'compareNotebooklm']}
    />
  )
}
